import React from "react";
import useController from "./useController";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  Title,
  BarElement,
  PointElement,
  LineElement,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Select, Button } from "../../components";
import { Controller } from "react-hook-form";

ChartJS.register(
  ArcElement,
  CategoryScale,
  PointElement,
  LineElement,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title
);

export default function DashboardPage() {
  const { state, options, handleSubmit, onSubmit, control, optionUnit, showOptionUnit } =
    useController();
  return (
    <div className="grid grid-cols-1 gap-2">
      <div className="flex flex-wrap justify-between items-center pb-2 border-b border-gray-300 rounded-t-md">
        <span className="font-semibold tracking-wide text-lg">Arus Kas</span>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-wrap gap-2 items-center">
            <div className="flex flex-col min-w-[250px]">
              {showOptionUnit && (
                <Controller
                  control={control}
                  name="unit"
                  render={({ field: { name, onChange, value } }) => {
                    return (
                      <Select
                        name={name}
                        value={value || ""}
                        isClearable
                        placeholder="Pilih Unit"
                        options={optionUnit}
                        onChange={(val) => onChange(val)}
                      />
                    );
                  }}
                />
              )}
            </div>
            <div className="flex flex-col min-w-[250px]">
              <Controller
                control={control}
                name="account"
                render={({ field: { name, onChange, value } }) => {
                  return (
                    <Select
                      name={name}
                      value={value || []}
                      isMulti
                      placeholder="Pilih Akun"
                      options={state?.accounts || []}
                      onChange={(val) => onChange(val)}
                    />
                  );
                }}
              />
            </div>
            <Button type="submit" padding="py-3 px-5">
              <span className="text-base">Cari</span>
            </Button>
          </div>
        </form>
      </div>
      <div className="flex p-2">
        <div className="flex items-center justify-center flex-1 h-[450px]">
          <Line data={state?.dataLine} options={options} redraw />
        </div>
      </div>
    </div>
  );
}
